module.exports = __webpack_public_path__ + "d2890538e7b348c5edec4bd648b4f3a7.png";